// assets
import { IconLambda, IconCode, IconRocket, IconChartLine, IconTestPipe, IconHistory } from '@tabler/icons-react';

// constant
const icons = {
    IconLambda,
    IconCode,
    IconRocket,
    IconChartLine,
    IconTestPipe,
    IconHistory
};

// ==============================|| LAMBDA FUNCTIONS MENU ITEMS ||============================== //

const lambdaFunctions = {
    id: 'lambda-functions',
    title: 'Lambda Functions',
    type: 'group',
    children: [
        {
            id: 'lambda-module',
            title: 'Lambda Functions',
            type: 'collapse',
            icon: icons.IconLambda,
            children: [
                {
                    id: 'lambda-dashboard',
                    title: 'Dashboard',
                    type: 'item',
                    url: '/lambda/dashboard',
                    breadcrumbs: false
                },
                {
                    id: 'lambda-functions-list',
                    title: 'All Functions',
                    type: 'item',
                    url: '/lambda/functions',
                    breadcrumbs: false
                },
                {
                    id: 'lambda-deploy',
                    title: 'Deploy Function',
                    type: 'item',
                    url: '/lambda/deploy',
                    breadcrumbs: false
                },
                {
                    id: 'lambda-metrics',
                    title: 'Metrics',
                    type: 'item',
                    url: '/lambda/metrics',
                    breadcrumbs: false
                },
                {
                    id: 'lambda-logs',
                    title: 'Execution Logs',
                    type: 'item',
                    url: '/lambda/logs',
                    breadcrumbs: false
                },
                {
                    id: 'lambda-testing',
                    title: 'Testing',
                    type: 'item',
                    url: '/lambda/test',
                    breadcrumbs: false
                },
                {
                    id: 'lambda-settings',
                    title: 'Settings',
                    type: 'item',
                    url: '/lambda/settings',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default lambdaFunctions;
